import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { formatPhoneNumber } from "../../utils/formatters";
import moment from "moment";

function UserContact(props) {
  props = {
    data: [],
    showDetails: true,
    showEmail: true,
    showPhone: true,
    membersAtRiskRawDataLink: "",
    nearlyExhausted: false,
    showMoreButton: true,
    ...props
  };
  return (
    <div>
      {props.data.length > 0 ? (
        <div>
          {!props.nearlyExhausted ? (
            <div>
              {props.data.map((item, index) => {
                const daysDiff = moment(item.lastVisitDate, "YYYY-MM-DD")
                  .diff(moment().subtract(1, "days").format("YYYY-MM-DD"), "days")
                  .toString()
                  .split("-");
                const name = item.clientName.split(" ");
                return (
                  <div className="contact-card" key={index} style={styles.item}>
                    <div className="left" style={[props.showDetails && styles.contactLeft]}>
                      <p className="client-name" style={styles.name}>
                        {item.clientName}
                      </p>
                      {props.showPhone ? (
                        <p className="client-phone" style={styles.phone}>
                          <a
                            className="client-tel"
                            style={styles.phone}
                            href={"tel:" + item.clientPhone}
                          >
                            {formatPhoneNumber(item.clientPhone)}
                          </a>
                        </p>
                      ) : null}

                      {props.showEmail ? (
                        <p className="client-email" style={styles.email}>
                          <img
                            alt={"client-email-icon"}
                            className="client-email-icon"
                            style={styles.email.icon}
                            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0OTMuNSA0OTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDkzLjUgNDkzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojODc5MWEwO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00NDQuNiw4NS4ySDQ4LjljLTI3LDAtNDguOSwyMi00OC45LDQ4Ljl2MjI1LjJjMCwyNywyMiw0OC45LDQ4LjksNDguOWgzOTUuNmMyNywwLDQ4LjktMjIsNDguOS00OC45VjEzNC4yQzQ5My41LDEwNy4yLDQ3MS41LDg1LjIsNDQ0LjYsODUuMnogTTQ2MC45LDEzNC4ydjIyNS4yYzAsMi42LTAuNyw0LjktMS44LDcuMUwzNDMuNywyNTEuMUw0NjAuOCwxMzRDNDYwLjgsMTM0LDQ2MC45LDEzNC4xLDQ2MC45LDEzNC4yeiBNMzIuNiwzNTkuM1YxMzQuMmMwLTAuMSwwLTAuMSwwLTAuMmwxMTcuMSwxMTcuMUwzNC40LDM2Ni40QzMzLjQsMzY0LjMsMzIuNiwzNjEuOSwzMi42LDM1OS4zeiBNMjUxLjgsMjk2LjljLTIuNywyLjctNy40LDIuNy0xMC4xLDBsLTE3OS0xNzkuMWgzNjguMkwyNTEuOCwyOTYuOXogTTE3Mi44LDI3NC4ybDQ1LjgsNDUuOGM3LjUsNy41LDE3LjUsMTEuNiwyOC4xLDExLjZjMTAuNiwwLDIwLjYtNC4xLDI4LjEtMTEuNmw0NS44LTQ1LjhsMTAxLjUsMTAxLjVINzEuM0wxNzIuOCwyNzQuMnoiLz48L3N2Zz4"
                          />
                          <a
                            className="client-email-link"
                            style={styles.email.link}
                            href={"mailto:" + item.clientEmail}
                          >
                            email
                          </a>
                        </p>
                      ) : null}
                    </div>
                    <div
                      className="right"
                      style={[styles.contactContainer, props.showDetails && styles.contactRight]}
                    >
                      <p>
                        It has been{" "}
                        <span className="days-diff" style={styles.contactRight.daysDiff}>
                          {daysDiff[1]}
                        </span>
                        {` days since ${name[0]}'s last visit. In the past 90 days ${name[0]} has spent `}
                        <span className="revenue" style={styles.contactRight.revenue}>
                          {item.revenue}
                        </span>
                        .
                      </p>
                    </div>
                  </div>
                );
              })}
              <div className="clear-fix" />
            </div>
          ) : (
            <div>
              {props.data.slice(0, 3).map((item, index) => {
                return (
                  <div className="contact-card" key={index} style={styles.item}>
                    <div className="left" style={[props.showDetails && styles.contactLeft]}>
                      <p className="client-name" style={styles.name}>
                        <a
                          style={styles.name.link}
                          target="_client_profile"
                          href={item.client_profile_link}
                        >
                          {item.first_name} {item.last_name}
                        </a>
                      </p>

                      <p className="client-phone" style={styles.phone}>
                        <a className="client-tel" style={styles.phone} href={"tel:" + item.phone}>
                          {formatPhoneNumber(item.phone)}
                        </a>
                      </p>

                      <p className="client-email" style={styles.email}>
                        <img
                          alt={"client-email-icon"}
                          className="client-email-icon"
                          style={styles.email.icon}
                          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0OTMuNSA0OTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDkzLjUgNDkzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojODc5MWEwO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00NDQuNiw4NS4ySDQ4LjljLTI3LDAtNDguOSwyMi00OC45LDQ4Ljl2MjI1LjJjMCwyNywyMiw0OC45LDQ4LjksNDguOWgzOTUuNmMyNywwLDQ4LjktMjIsNDguOS00OC45VjEzNC4yQzQ5My41LDEwNy4yLDQ3MS41LDg1LjIsNDQ0LjYsODUuMnogTTQ2MC45LDEzNC4ydjIyNS4yYzAsMi42LTAuNyw0LjktMS44LDcuMUwzNDMuNywyNTEuMUw0NjAuOCwxMzRDNDYwLjgsMTM0LDQ2MC45LDEzNC4xLDQ2MC45LDEzNC4yeiBNMzIuNiwzNTkuM1YxMzQuMmMwLTAuMSwwLTAuMSwwLTAuMmwxMTcuMSwxMTcuMUwzNC40LDM2Ni40QzMzLjQsMzY0LjMsMzIuNiwzNjEuOSwzMi42LDM1OS4zeiBNMjUxLjgsMjk2LjljLTIuNywyLjctNy40LDIuNy0xMC4xLDBsLTE3OS0xNzkuMWgzNjguMkwyNTEuOCwyOTYuOXogTTE3Mi44LDI3NC4ybDQ1LjgsNDUuOGM3LjUsNy41LDE3LjUsMTEuNiwyOC4xLDExLjZjMTAuNiwwLDIwLjYtNC4xLDI4LjEtMTEuNmw0NS44LTQ1LjhsMTAxLjUsMTAxLjVINzEuM0wxNzIuOCwyNzQuMnoiLz48L3N2Zz4"
                        />
                        <a
                          className="client-email-link"
                          style={styles.email.link}
                          href={"mailto:" + item.email}
                        >
                          email
                        </a>
                      </p>
                      <div className="metrics" style={styles.metrics}>
                        {item.metric.map((item, index) => {
                          return <p key={index}>{item}</p>;
                        })}
                      </div>
                    </div>
                    <div
                      className="right"
                      style={[styles.contactContainer, props.showDetails && styles.contactRight]}
                    >
                      <p>
                        {item.first_name} {item.last_name} has a <b>{item.product_name}</b> pricing
                        option that expires {item.sale_exp_date} and is scheduled for{" "}
                        {item.scheduled_class} at {item.visit_time} today. <br />
                        <br />
                        {item.first_name} has averaged{" "}
                        <span className="revenue" style={styles.contactRight.revenue}>
                          {item.avg_3wk}
                        </span>{" "}
                        visits per week over the last 3 weeks.
                        {item.remained !== "N/A" &&
                          `There are ${item.remained} sessions remaining on this pricing option.`}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {props.showMoreButton ? (
            <div className="client-see-list" style={styles.seeList}>
              <a
                href={props.membersAtRiskRawDataLink}
                style={styles.seeList.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                See full list ({props.total})
              </a>
            </div>
          ) : null}
        </div>
      ) : (
        <p style={styles.noData}>No data found.</p>
      )}
    </div>
  );
}

const styles = {
  metrics: {
    float: "left",
    margin: "0 0 0 -55px",
    lineHeight: "6px",
    paddingTop: "35px"
  },
  noData: {
    color: "rgb(135, 145, 160)"
  },
  contactContainer: {
    display: "none"
  },
  contactLeft: {
    width: "205px",
    float: "left",
    display: "block",
    marginTop: "-6px",
    marginBottom: "10px"
  },
  contactRight: {
    width: "400px",
    float: "right",
    lineHeight: "20px",
    display: "block",
    marginTop: "-10px",
    daysDiff: {
      color: "rgb(199, 52, 62)"
    },
    revenue: {
      color: "rgb(33, 233, 129)"
    }
  },
  item: {
    color: "rgb(135, 145, 160)",
    lineHeight: "13px",
    float: "left",
    width: "auto",
    marginBottom: "15px",
    padding: "25px 25px 5px 25px",
    backgroundColor: "#1b1d22",
    noBottomBorder: {
      borderBottom: "none"
    }
  },
  firstItem: {
    paddingLeft: "0px"
  },
  name: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    paddingBottom: "3px",
    link: {
      color: "rgb(74, 154, 255)",
      fontWeight: "800",
      lineHeight: "24px"
    }
  },
  phone: {
    color: "rgb(74, 154, 255)",
    marginTop: "-3px",
    marginBottom: "0"
  },
  email: {
    textTransform: "uppercase",
    fontSize: "12px",
    icon: {
      width: "22px",
      display: "inline-block",
      float: "left",
      marginTop: "5px",
      paddingRight: "6px"
    },
    link: {
      color: "rgb(74, 154, 255)",
      textDecoration: "none",
      float: "left",
      marginTop: "6px"
    }
  },
  seeList: {
    float: "left",
    width: "675px",
    textAlign: "center",
    marginTop: "25px",
    link: {
      color: "rgb(74, 154, 255)"
    }
  }
};

export default Radium(UserContact);

UserContact.propTypes = {
  data: PropTypes.array,
  showDetails: PropTypes.string,
  showEmail: PropTypes.bool,
  showPhone: PropTypes.bool,
  nearlyExhausted: PropTypes.bool,
  showMoreButton: PropTypes.bool,
  membersAtRiskRawDataLink: PropTypes.string,
  total: PropTypes.number
};
